module.exports = __webpack_public_path__ + "img/btn-back.cb4d2b24.png";